function create_flood_sensor_geojson(data){
    if (!raw_data["淹水感知器與雨水下水道測站關聯距離資料"]) {
        raw_data["淹水感知器與雨水下水道測站關聯距離資料"] = ajax_call(publicPath + "/napi/flood/flood_sewer_sensor_relation_data")
    }
    let geoJson = turf.featureCollection([])
    data.forEach(element => {
        // element.villname ??= "-"
        if (!element.villname) {
            element.villname = "-"
        }
        if (element.iow_id === "") {
            element.time = "-"
            element.level = "-"
            element.status = "離線"
        } else {
            element.time = element.time.slice(0,16).replace("T", " ")
            element.level = element.level.toFixed(0)
            // let timeLag = get_now_time_UTC() - time_sql_processing(element.time)
            // if (timeLag > 3600000 * 6) {
            //     element.status = "離線"
            // } else {
            //     switch(true){
            //         case (Number(element.level) >= 30):
            //             element.status = "淹水"
            //             break
            //         case (Number(element.level) >= 10 && Number(element.level) < 30):
            //             element.status = "積水"
            //             break
            //         default:
            //             element.status = "未達"
            //     }
            // }
            if (element.status === "正常") {
                element.status = "未達"
            }
        }
        geoJson.features.push({
            "type": "Feature",
            "geometry": {
                  "type": "Point",
                  "coordinates": [element.lon, element.lat]
            },
            "properties": element
        })
    })
    return geoJson
}

function create_sewer_sensor_geojson(data){
    let geoJson = turf.featureCollection([])
    data.forEach(element => {
        let thisPointGeom = JSON.parse(element.geom).coordinates
        geoJson.features.push({
            "type": "Feature",
            "geometry": {
                  "type": "Point",
                  "coordinates": thisPointGeom
            },
            "properties": element
        })
    })
    return geoJson
}

function layer_sewer_sensor(){
    let geoJson = turf.featureCollection([])
    if (raw_data["雨水下水道"]) {
        geoJson = raw_data["雨水下水道"]
    } else {
        let dataStation = ajax_call(publicPath + "/napi/flood/sewer_sensor_list")
        if (dataStation) {
            geoJson = create_sewer_sensor_geojson(dataStation.data)
        }
    }
    let thisLayer = L.geoJSON(geoJson, {
		pointToLayer: function(feature, latlng) {
            let iconUrl = "marker_icon/sewer_sensor.png"
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: iconUrl,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="other_area">資料連結中...</div>')
		}
    }).on('click', function(e){
		let thisMarker = e.layer.feature.properties
		setTimeout(function(){
			$('#other_area').html(`
                <h6>地址：${thisMarker.address}</h6>
                <h6>行政區 / 村里：${thisMarker.townname} / ${thisMarker.villname}</h6>
                <h6>半滿管：${String(thisMarker.h1)}m</h6>
                <h6>滿管：${String(thisMarker.h2)}m</h6>
                <h6>溢出路面：${String(thisMarker.h3)}m</h6>
                <h6>觀測時間：-</h6>
                <h6>觀測深度：-m</h6>
                <h6>街景連結：<button type="button" class="btn btn-link p-0 point-google-street" lon="${e.layer.feature.geometry.coordinates[0]}" lat="${e.layer.feature.geometry.coordinates[1]}">另開分頁檢視</button></h6>`
			)
		}, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}

function layer_flood_sensor(target = ''){
    let geoJson = turf.featureCollection([]),
        depthGridcode = { "1": { label: "<0.3m", color: "#ffffff"}, "2": { label: "0.3m~1m", color: "#ffcc66"}, "3": { label: "1m~2m", color: "#ff6600"}, "4": { label: "2m~3m", color: "#ff0000"}, "5": { label: "3m~4m", color: "#990000"}, "6": { label: "4m~5m", color: "#990000"}, "7": { label: "5m~6m", color: "#990000"}, "8": { label: ">6m", color: "#990000"}}
    if (raw_data["淹水感知器"]) {
        geoJson = raw_data["淹水感知器"]
    } else {
        let dataStation = ajax_call(publicPath + "/napi/flood/get_flood_sensor_list_obs/all")
        if (dataStation) {
            geoJson = create_flood_sensor_geojson(dataStation.data)
        }
    }
    let thisLayer = L.geoJSON(geoJson, {
		pointToLayer: function(feature, latlng) {
            let iconUrl = ""
            switch (feature.properties.status) {
                case "未達":
                    iconUrl = "marker_icon/flooding_sensor.png"
                    break
                case "積水":
                    iconUrl = "marker_icon/flooding_sensor_30.png"
                    break
                case "淹水":
                    iconUrl = "marker_icon/flooding_sensor_50.png"
                    break
                case "離線":
                    iconUrl = "marker_icon/flooding_sensor_null.png"
                    break
            }
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: iconUrl,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="other_area">資料連結中...</div>')
		},
        filter: (feature, layer) => {
			switch (target) {
				case '淹水':
					return feature.properties.status == '淹水'
				case '積水':
					return feature.properties.status == '積水'
				case '未達':
					return feature.properties.status == '未達'
				case '離線':
					return feature.properties.status == '離線'
				default:
					return feature
			}
		}
    }).on('click', function(e){
		let thisMarker = e.layer.feature.properties,
            nowLevelValue = Number(thisMarker.level),
            depthOptionHtml = layer_flood_sensor_create_option(nowLevelValue)
		setTimeout(function(){
			$('#other_area').html(`
				<h6>測站：${thisMarker.st_name}</h5>
                <h6>行政區 / 村里：${thisMarker.townname} / ${thisMarker.villname}</h6>
                <h6 id="advanced_info">進階資訊：<button type="button" class="btn btn-link btn-sm p-0" id="layer-flood-sensor-detail-page-trig">淹水範圍推估與鄰近觀測資訊</button></h6>
                <h6>觀測時間：${thisMarker.time}</h6>
                <h6>觀測深度：${thisMarker.level}cm</h6>
                <h6>狀態：${thisMarker.status}</h6>
                <h6>街景連結：<button type="button" class="btn btn-link p-0 point-google-street" lon="${thisMarker.lon}" lat="${thisMarker.lat}">另開分頁檢視</button></h6>`
			)
            if (!thisMarker.wrs_id) { $('#advanced_info').addClass("d-none") }
            $("#layer-flood-sensor-detail-page-trig").click(function(){
                modal_open(`
                    <ul class="nav nav-tabs w-100 mb-2" role="tablist">
                        <li class="nav-item text-center w-50" role="presentation">
                            <a class="nav-link active" data-toggle="tab" href="#layer-flood-sensor-detail-page-area" role="tab">淹水範圍推估</a>
                        </li>
                        <li class="nav-item text-center w-50" role="presentation">
                            <a class="nav-link" data-toggle="tab" href="#layer-flood-sensor-detail-page-obs" role="tab">鄰近觀測資訊</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="layer-flood-sensor-detail-page-area" role="tabpanel">
                            <div class="row">
                                <div class="col-5">
                                    <h5 class="font-weight-bold">最新一筆觀測紀錄</h5>
                                    <ul>
                                        <li>觀測時間：${thisMarker.time}</li>
                                        <li>觀測水深：${thisMarker.level}cm</li>
                                        <li>狀態：${thisMarker.status}</li>
                                    </ul>
                                    <h5 class="font-weight-bold">淹水範圍推估統計</h5>
                                    <div class="input-group input-group-sm mb-3">
                                        <div class="input-group-prepend">
                                            <label class="input-group-text">感測器深度選擇</label>
                                        </div>
                                        <select class="custom-select" id="flood-sensor-depth-area-selector">${depthOptionHtml}</select>
                                    </div>
                                    <table class="table table-sm table-bordered text-center" id="flood-sensor-depth-area-table">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>深度</th>
                                                <th>圖例</th>
                                                <th>面積</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colspan="3">此深度沒有淹水結果</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-7">
                                    <div class="w-100" id="modal-map" style="height: 400px;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="layer-flood-sensor-detail-page-obs" role="tabpanel">
                            <div class="row"></div>
                        </div>
                    </div>`,
                    `「${thisMarker.st_name}」淹水感知器進階資訊`,
                    function(){
                        // 淹水範圍推估-地圖設定
                        let modalMap = new L.Map('modal-map', {
                                attributionControl: false,
                                zoomControl: false,
                                center: new L.LatLng(e.layer.feature.geometry.coordinates[1], e.layer.feature.geometry.coordinates[0]),
                                zoom: 18,
                                zoomSnap: 0,
                                zoomDelta: 0.25,
                                wheelPxPerZoomLevel: 100,
                                layers: L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{ maxZoom: 22, subdomains:['mt0','mt1','mt2','mt3'], opacity: 0.8 })
                            }),
                            thisStation = L.geoJSON(e.layer.feature).addTo(modalMap),
                            thisFloodAreaLayer,
                            thisWrsId = thisMarker.wrs_id
                        // 淹水範圍推估-事件綁定
                        $("#flood-sensor-depth-area-selector").change(function(){
                            let thisValue = $(this).val()
                            if (thisFloodAreaLayer) {
                                modalMap.removeLayer(thisFloodAreaLayer)
                            }
                            thisFloodAreaLayer = change_flooding_layer(thisWrsId, thisValue).addTo(modalMap)
                            change_flooding_table(thisFloodAreaLayer.toGeoJSON())
                        }).trigger("change")
                        // 鄰近觀測資訊
                        let thisVillageOtherStationList = [e.layer.feature].concat(raw_data["淹水感知器"].features.filter(feature => { return (feature.properties.villname === thisMarker.villname && feature.properties.townname === thisMarker.townname) && (feature.properties.wrs_id !== thisWrsId) })),
                            neighborObsChartHtml = ""
                        // 相同村里淹感
                        thisVillageOtherStationList.forEach(feature => {
                            if (feature.properties.iow_id !== "") {
                                neighborObsChartHtml += `<div id="flood-sensor-chart-${feature.properties.wrs_id}" class="col-6" style="height: 320px;"></div>`
                                setTimeout(function(){
                                    ajax_call_async(
                                        publicPath + "/napi/flood/get_flood_sensor_list_obs/" + feature.properties.iow_id,
                                        function(data){
                                            let seriesArray = []
                                            data.data.reverse().forEach(el => {
                                                seriesArray.push([time_sql_processing(el.time), el.level])
                                            })
                                            any_series_chart_render({
                                                title: "淹水感知器(" + feature.properties.st_name + ")",
                                                data: [seriesArray],
                                                renderdiv: `flood-sensor-chart-${feature.properties.wrs_id}`,
                                                plot_type: ["spline"],
                                                series_name: ["水位"],
                                                series_color: ["blue"]
                                            })
                                        }
                                    )
                                }, 1000)
                            } else {
                                neighborObsChartHtml += `
                                    <div id="flood-sensor-chart-${feature.properties.wrs_id}" class="col-6 text-center" style="height: 320px;">
                                        淹水感知器(${feature.properties.st_name})無觀測資訊
                                    </div>`
                            }
                        })
                        // 最近雨量站
                        try {
                            if (raw_data["淹水感知器與雨水下水道測站關聯距離資料"].floodsensor[thisMarker.st_name].rain.length > 0) {
                                let thisNearestRainStationId = raw_data["淹水感知器與雨水下水道測站關聯距離資料"].floodsensor[thisMarker.st_name].rain[0]
                                neighborObsChartHtml += `<div id="flood-sensor-relation-rain-chart" class="col-6" style="height: 320px;"></div>`
                                ajax_call_async(
                                    `${publicPath}/napi/obs/rainobs?STID=${thisNearestRainStationId}&StartTime=${sql_query_start_time(thisMarker.time)}&EndTime=${thisMarker.time}`,
                                    function(data){
                                        let seriesArray = []
                                        data.forEach(el => {
                                            if (el["TIME"].slice(14,16) === "00") {
                                                seriesArray.push([time_sql_processing(el["TIME"]), rain_value_processing(el["RAIN"])])
                                            }
                                        })
                                        any_series_chart_render({
                                            title: "雨量站(" + thisNearestRainStationId + ")",
                                            data: [seriesArray],
                                            renderdiv: "flood-sensor-relation-rain-chart",
                                            plot_type: ["column"],
                                            series_name: ["時雨量"],
                                            series_color: ["blue"]
                                        })
                                    }
                                )
                            }
                        } catch(e) {
                            neighborObsChartHtml = '<div class="col-12"><p class="text-center">無鄰近資訊</p></div>'
                        }

                        // 畫布div渲染
                        $("#layer-flood-sensor-detail-page-obs div.row").html(neighborObsChartHtml)

                        // 淹水範圍推估-函式
                        function change_flooding_layer(wrs_id, depth){
                            let data = ajax_call(publicPath + `/napi/flood/flooding_area?name=['${wrs_id}']&depth=[${depth}]`),
                                thisGeojson = turf.featureCollection([])
                            if (data) {
                                thisGeojson = preProcessingData.pssqlGeojson(data.data, "geom")
                            }
                            return L.geoJSON(thisGeojson, {
                                style: function(feature){
                                    return {
                                        fillColor: depthGridcode[String(feature.properties.gridcode)].color,
                                        weight: 0,
                                        fillOpacity: 0.7
                                    }
                                }
                            })
                        }
                        function change_flooding_table(geoJson){
                            let tbodyHtml = ""
                            geoJson.features.sort(function(a, b){
                                return a.properties.gridcode - b.properties.gridcode
                            })
                            geoJson.features.forEach(function(feature){
                                let thisArea = turf.area(feature)
                                tbodyHtml += `
                                    <tr>
                                        <td>${depthGridcode[feature.properties.gridcode].label}</td>
                                        <td style="background-color: ${depthGridcode[feature.properties.gridcode].color}; opacity: 0.7;"></td>
                                        <td>${thisArea.toFixed(0)}m<sup>2</sup></td>
                                    </tr>`
                            })
                            if (tbodyHtml === "") {
                                tbodyHtml = `<tr><td colspan="3">此深度沒有淹水結果</td></tr>`
                            }
                            $("#flood-sensor-depth-area-table tbody").html(tbodyHtml)
                        }
                    }
                )
            })
		}, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}

function layer_flood_sensor_create_option(now_depth){
    let optionHtml = ""
    if (now_depth < 10) {
        now_depth = 0
    } else {
        let now_depth_length = String(now_depth).length
        switch(now_depth_length){
            case 2:
                now_depth = Number(String(now_depth).slice(0,1) + "0")
                break
            case 3:
                now_depth = Number(String(now_depth).slice(0,2) + "0")
                break
        }
    }
    for (let i = 0; i < 31; i++) {
        let selected = ""
        if (now_depth == i*10) {
            selected = 'selected style="background-color: red; opacity: 0.5;"'
        }
        optionHtml += `<option value="${i*10}" ${selected}>深度${i*10}cm</option>`
    }
    return optionHtml
}

function layer_history_flood_points () {
    raw_data["歷史淹水點位NCDR"] ??= ajax_call("geojson/history_flood/history_flood_points.geojson")
	var data = raw_data["歷史淹水點位NCDR"]
	var history_flood_points_layer = L.geoJSON(data,{
		pointToLayer: function(feature, latlng) {
			return L.circleMarker(latlng, {
                radius: 8,
                fillOpacity: 1,
                fillColor: 'red',
                color: 'white',
                weight: 2
            })
        }
    })

    return history_flood_points_layer
}

function layer_history_flood_area(){
	raw_data["歷史淹水範圍NCDR"] ??= ajax_call("geojson/history_flood/history_flood_area.geojson")
	var data = raw_data["歷史淹水範圍NCDR"]
	var history_flood_area_layer = L.geoJSON(data,{
		style: {
			weight: 2,
			opacity: 1,
			color: 'blue',
			fillColor: 'blue',
			fillOpacity: 0.5
		}
	})

	return history_flood_area_layer
}

function create_underpass_geojson(data){
    let geoJson = turf.featureCollection([])
    data.forEach(element => {
		const time_lag = new Date().getTime() - new Date(element.update_time).getTime();
        // Determine status based on flood_level and time lag
        if (time_lag > 3600000 * 2) {
            element.flood_status = "離線"
        } else {
            switch(element.flood_level) {
                case 0:
                    element.flood_status = "未達警戒"
                    break
                case 1:
                case 2:
                    element.flood_status = "積水"
                    break
                case 3:
                    element.flood_status = "淹水"
                    break
                default:
                    element.flood_status = "未達警戒"
            }
        }

        geoJson.features.push({
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [element.lng, element.lat]
            },
            "properties": element
        })
    })
    return geoJson
}

function layer_underpass_water(target = ''){
    let geoJson = turf.featureCollection([])
    if (raw_data["車行地下道水位監測"]) {
        geoJson = create_underpass_geojson(raw_data["車行地下道水位監測"])
    } else {
        let dataStation = ajax_call(publicPath + "/napi/underpass")
        if (dataStation) {
            geoJson = create_underpass_geojson(dataStation)
        }
    }
    let thisLayer = L.geoJSON(geoJson, {
        pointToLayer: function(feature, latlng) {
            let iconUrl = ""
            switch (feature.properties.flood_status) {
                case "未達警戒":
                    iconUrl = "marker_icon/flooding_sensor.png"
                    break
                case "積水":
                    iconUrl = "marker_icon/flooding_sensor_30.png"
                    break
                case "淹水":
                    iconUrl = "marker_icon/flooding_sensor_50.png"
                    break
                case "離線":
                    iconUrl = "marker_icon/flooding_sensor_null.png"
                    break
            }
            return L.canvasMarker(latlng, {
                radius: 15,
                img: {
                    url: iconUrl,
                    size: [32, 32],
                    offset: { x: 0, y: 0 },
                }
            }).bindPopup('<div id="other_area">資料連結中...</div>')
        },
        filter: (feature, layer) => {
            switch (target) {
                case '淹水':
                    return feature.properties.flood_status == '淹水'
                case '積水':
                    return feature.properties.flood_status == '積水'
                case '未達警戒':
                    return feature.properties.flood_status == '未達警戒'
                case '離線':
                    return feature.properties.flood_status == '離線'
                default:
                    return feature
            }
        }
    }).on('click', function(e){
        let thisMarker = e.layer.feature.properties
        setTimeout(function(){
            let floodLevelText = ''
            switch(thisMarker.flood_level) {
                case 0:
                    floodLevelText = '無淹水'
                    break
                case 1:
                    floodLevelText = '淹水<10cm'
                    break
                case 2:
                    floodLevelText = '淹水10~20cm'
                    break
                case 3:
                    floodLevelText = '淹水>20cm'
                    break
                default:
                    floodLevelText = '-'
            }
            $('#other_area').html(`
                <h6>地下道：${thisMarker.name || '-'}</h6>
                <h6>行政區：${thisMarker.district || '-'}</h6>
                <h6>說明：${thisMarker.description || '-'}</h6>
                <h6>觀測時間：${thisMarker.update_time}</h6>
                <h6>水位高度：${thisMarker.gage_height !== undefined ? thisMarker.gage_height + 'cm' : '-'}</h6>
                <h6>淹水程度：${floodLevelText}</h6>
                <h6>狀態：${thisMarker.flood_status}</h6>
                <h6>街景連結：<button type="button" class="btn btn-link p-0 point-google-street" lon="${thisMarker.lng}" lat="${thisMarker.lat}">另開分頁檢視</button></h6>`
            )
        }, 1000);
    })
    let result = [thisLayer, geoJson]
    return result
}